import { render } from "./EmployeeDeniedPrs.vue?vue&type=template&id=5f671ceb"
import script from "./EmployeeDeniedPrs.vue?vue&type=script&lang=js"
export * from "./EmployeeDeniedPrs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__